
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event-services",
      function () {
        return require("private-next-pages/event-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event-services"])
      });
    }
  